// src/pages/user/SubscriptionPage.jsx
import { useEffect, useState } from "react";
import {
  Crown,
  Check,
  X,
  CreditCard,
  Zap,
  Star,
  Sparkles,
  Gift,
  ExternalLink,
  RefreshCw,
} from "lucide-react";
import { useToast } from "../../components/ToastProvider";
import { injectUserStyles } from "./userStyles";

const STYLE_ID = "sub-page-styles";
function injectLocal() {
  injectUserStyles();
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement("style");
  el.id = STYLE_ID;
  el.textContent = `
    .sub-wrap { font-family:'DM Sans',sans-serif; color:#0c1118; }
    .sub-banner {
      border-radius:10px; padding:20px 24px;
      display:flex; align-items:center; justify-content:space-between;
      gap:16px; flex-wrap:wrap; margin-bottom:24px;
    }
    .sub-banner-active   { background:#0c1118; }
    .sub-banner-upgrade  { background:linear-gradient(135deg,#1e2832 0%,#0c1118 100%); border:1px solid rgba(249,171,20,.2); }
    .sub-banner-icon {
      width:44px; height:44px; border-radius:10px;
      background:rgba(255,255,255,.1); display:flex; align-items:center; justify-content:center;
      flex-shrink:0;
    }
    .sub-banner-title { font-family:'DM Sans',sans-serif; font-size:1.4rem; font-weight:700; letter-spacing:.04em; color:#fff; line-height:1; }
    .sub-banner-sub   { font-size:12px; color:rgba(255,255,255,.5); margin-top:3px; }
    .sub-interval-toggle {
      display:flex; align-items:center; justify-content:center; margin-bottom:28px;
    }
    .sub-interval-wrap {
      background:#f3f4f6; border-radius:9px; padding:4px; display:inline-flex; gap:2px;
    }
    .sub-interval-btn {
      padding:8px 20px; border-radius:7px; font-size:13px; font-weight:500;
      cursor:pointer; border:none; transition:all 180ms;
    }
    .sub-interval-btn.active { background:#0c1118; color:#fff; }
    .sub-interval-btn:not(.active) { background:transparent; color:#6b7280; }
    .sub-interval-btn:not(.active):hover { color:#374151; }
    .sub-plans-grid {
      display:grid; gap:20px; margin-bottom:32px;
    }
    .sub-plan-card {
      background:#fff; border:1px solid #e8ecf0; border-radius:12px; overflow:hidden;
      position:relative; transition:box-shadow 200ms;
    }
    .sub-plan-card:hover { box-shadow:0 6px 20px rgba(0,0,0,.08); }
    .sub-plan-card.popular  { border-color:rgba(99,102,241,.4); border-width:2px; }
    .sub-plan-card.current  { border-color:rgba(16,185,129,.4); border-width:2px; }
    .sub-plan-badge {
      position:absolute; top:-1px; left:50%; transform:translateX(-50%);
      padding:4px 14px; border-radius:0 0 8px 8px;
      font-family:'DM Sans',sans-serif; font-size:10px; letter-spacing:.08em;
      font-weight:500; white-space:nowrap;
    }
    .sub-plan-badge.popular { background:#6366f1; color:#fff; }
    .sub-plan-badge.current { background:#10b981; color:#fff; }
    .sub-plan-body { padding:24px; }
    .sub-plan-name {
      font-family:'DM Sans',sans-serif;
      font-size:1.6rem; letter-spacing:.04em; color:#0c1118;
    }
    .sub-plan-desc { font-size:12.5px; color:#9ca3af; margin-top:3px; }
    .sub-plan-price {
      font-family:'DM Sans',sans-serif;
      font-size:2.4rem; font-weight:700; letter-spacing:.02em; color:#0c1118; line-height:1;
      margin:14px 0 0;
    }
    .sub-plan-interval { font-size:13px; color:#9ca3af; margin-top:2px; }
    .sub-plan-discount {
      display:inline-flex; align-items:center; gap:4px;
      padding:2px 8px; border-radius:4px;
      background:rgba(16,185,129,.1); color:#065f46;
      font-family:'DM Sans',sans-serif; font-size:10px; letter-spacing:.04em;
      margin-top:6px;
    }
    .sub-plan-features { margin:18px 0 20px; display:flex; flex-direction:column; gap:9px; }
    .sub-plan-feat-row { display:flex; align-items:center; gap:9px; font-size:13px; }
    .sub-plan-feat-icon {
      width:18px; height:18px; border-radius:50%; flex-shrink:0;
      display:flex; align-items:center; justify-content:center;
    }
    .sub-plan-feat-icon.yes { background:rgba(16,185,129,.12); }
    .sub-plan-feat-icon.no  { background:#f3f4f6; }
    .sub-plan-cta {
      width:100%; padding:11px; border-radius:8px;
      font-size:13.5px; font-weight:600; cursor:pointer; border:none;
      transition:background 150ms; display:flex; align-items:center; justify-content:center; gap:7px;
    }
    .sub-plan-cta.upgrade  { background:#0c1118; color:#fff; }
    .sub-plan-cta.upgrade:hover { background:#1e2832; }
    .sub-plan-cta.current  { background:#f3f4f6; color:#9ca3af; cursor:default; }
    .sub-plan-cta.disabled  { background:#f3f4f6; color:#9ca3af; cursor:not-allowed; }
    .sub-plan-cta.downgrade { background:#f9fafb; color:#374151; border:1.5px solid #d1d5db; }
    .sub-plan-cta.downgrade:hover { background:#f3f4f6; border-color:#9ca3af; }
    .sub-info-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:16px; margin-bottom:32px; }
    @media (max-width:767px) { .sub-info-grid { grid-template-columns:1fr; } }
    .sub-info-card { background:#fff; border:1px solid #e8ecf0; border-radius:10px; padding:18px 20px; }
    .sub-info-title {
      font-family:'DM Sans',sans-serif; font-size:10px; letter-spacing:.04em;
      color:#9ca3af; margin-bottom:8px;
    }
    .sub-info-value { font-size:14px; font-weight:600; color:#0c1118; }
    .sub-info-sub   { font-size:12px; color:#9ca3af; margin-top:3px; }
    .sub-coupon-wrap {
      max-width: 480px; margin: 0 auto 28px; display: flex; flex-direction: column; gap: 10px;
    }
    .sub-coupon-row {
      display: flex; gap: 8px; align-items: stretch;
    }
    .sub-coupon-input {
      flex: 1; padding: 10px 14px; border-radius: 8px;
      border: 1.5px solid #e8ecf0; font-family:'DM Sans',sans-serif;
      font-size: 13.5px; letter-spacing: 0.08em; color: #0c1118;
      outline: none; transition: border-color 180ms;
      background: #fff;
    }
    .sub-coupon-input:focus { border-color: #f9ab14; box-shadow: 0 0 0 3px rgba(249,171,20,0.12); }
    .sub-coupon-input.valid   { border-color: #10b981; }
    .sub-coupon-input.invalid { border-color: #ef4444; }
    .sub-coupon-apply {
      padding: 10px 18px; border-radius: 8px; border: none; cursor: pointer;
      background: #0c1118; color: #fff; font-family:'DM Sans',sans-serif;
      font-size: 13px; font-weight: 600; transition: background 150ms;
      white-space: nowrap; display: flex; align-items: center; gap: 6px;
    }
    .sub-coupon-apply:hover:not(:disabled) { background: #1e2832; }
    .sub-coupon-apply:disabled { opacity: 0.55; cursor: not-allowed; }
    .sub-coupon-feedback {
      display: flex; align-items: center; gap: 8px;
      padding: 10px 14px; border-radius: 8px; font-size: 13px;
      font-family:'DM Sans',sans-serif;
    }
    .sub-coupon-feedback.valid   { background: rgba(16,185,129,0.08); color: #065f46; border: 1px solid rgba(16,185,129,0.25); }
    .sub-coupon-feedback.invalid { background: rgba(239,68,68,0.07);  color: #b91c1c; border: 1px solid rgba(239,68,68,0.2); }
    .sub-coupon-clear {
      background: none; border: none; cursor: pointer; color: inherit;
      font-size: 11px; margin-left: auto; opacity: 0.6; padding: 0 4px;
      font-family:'DM Sans',sans-serif; text-decoration: underline;
    }
    .sub-coupon-clear:hover { opacity: 1; }
    .sub-compare-table table { width:100%; border-collapse:collapse; font-size:13px; }
    .sub-compare-table thead tr { background:#f9fafb; border-bottom:1px solid #e8ecf0; }
    .sub-compare-table th { padding:12px 16px; font-family:'DM Sans',sans-serif; font-size:9.5px; letter-spacing:.04em; color:#9ca3af; text-align:center; }
    .sub-compare-table th:first-child { text-align:left; }
    .sub-compare-table td { padding:12px 16px; border-bottom:1px solid #f3f4f6; text-align:center; }
    .sub-compare-table td:first-child { text-align:left; font-weight:500; color:#374151; }
    .sub-compare-table tbody tr:last-child td { border-bottom:none; }
    .sub-compare-table tbody tr:nth-child(even) { background:#fafafa; }
  `;
  document.head.appendChild(el);
}

async function fetchJson(url, opts) {
  const r = await fetch(url, { credentials: "include", ...opts });
  if (!r.ok) throw new Error(await r.text().catch(() => r.statusText));
  return r.json();
}

/* ── Helpers (preserved exactly) ── */
function featureValue(plan, key, fallback) {
  const f = (plan.features || []).find((x) => x.key === key);
  return f?.valueInt ?? fallback;
}

function has(plan, key) {
  const f = (plan.features || []).find((x) => x.key === key);
  if (!f) return false;
  return f.valueInt != null
    ? !!f.valueInt
    : f.valueString != null
      ? !!f.valueString
      : f.valueJson != null
        ? !!f.valueJson
        : true;
}

function planDefaultMax(code) {
  return code === "tier1"
    ? 10
    : code === "tier2"
      ? 30
      : code === "tier3"
        ? 50
        : 5;
}

function orgDefaultSeats(code) {
  return code === "company_basic"
    ? 3
    : code === "company_pro"
      ? 10
      : code === "company_enterprise"
        ? 25
        : 1;
}

function orgHeaderText(role) {
  if (role === "owner")
    return "As the owner, you can manage the company subscription and billing.";
  if (role === "admin")
    return "You can manage the company subscription and billing.";
  return "You can view the subscription and available plans for your company.";
}

/* ── Main ── */
export default function SubscriptionPage() {
  useEffect(() => {
    injectLocal();
  }, []);

  const [auth, setAuth] = useState(null);
  const [scope, setScope] = useState("individual");
  const [me, setMe] = useState(null);
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [billingInterval, setBillingInterval] = useState("month");

  // ── Coupon state ──────────────────────────────────────────────────────────
  const [couponCode, setCouponCode] = useState("");
  const [couponState, setCouponState] = useState(null);
  // couponState: null | { status: "validating"|"valid"|"invalid", reason?, discount? }
  const [couponValidating, setCouponValidating] = useState(false);

  const toast = useToast();

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const authRes = await fetchJson(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`,
        );
        setAuth(authRes);
        const defaultScope = authRes?.primaryOrg
          ? "organization"
          : "individual";
        setScope(defaultScope);
        const plansRes = await fetchJson(
          `${process.env.REACT_APP_BACKEND_URL}/api/plans`,
        );
        setPlans(plansRes.items || []);
        if (defaultScope === "organization") {
          setMe(
            await fetchJson(
              `${process.env.REACT_APP_BACKEND_URL}/api/org-billing/me`,
            ),
          );
        } else {
          setMe(
            await fetchJson(
              `${process.env.REACT_APP_BACKEND_URL}/api/billing/me`,
            ),
          );
        }
      } catch (e) {
        console.error("Failed to load subscription data:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function reloadMe() {
    try {
      if (scope === "organization")
        setMe(
          await fetchJson(
            `${process.env.REACT_APP_BACKEND_URL}/api/org-billing/me`,
          ),
        );
      else
        setMe(
          await fetchJson(
            `${process.env.REACT_APP_BACKEND_URL}/api/billing/me`,
          ),
        );
    } catch (e) {
      console.error(e);
    }
  }

  // ── Coupon validation ─────────────────────────────────────────────────────
  async function validateCoupon() {
    const code = couponCode.trim().toUpperCase();
    if (!code) return;

    setCouponValidating(true);
    setCouponState({ status: "validating" });
    try {
      const endpoint = isOrg
        ? `${process.env.REACT_APP_BACKEND_URL}/api/org-billing/validate-coupon`
        : `${process.env.REACT_APP_BACKEND_URL}/api/billing/validate-coupon`;

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ code }),
      });
      const data = await res.json();

      if (data.valid) {
        setCouponState({
          status: "valid",
          discount: data.discount,
          expiresAt: data.expiresAt,
        });
        // Normalize code to uppercase in the input field
        setCouponCode(code);
      } else {
        setCouponState({
          status: "invalid",
          reason: data.reason || "Invalid coupon code",
        });
        toast.error(data.reason || "Invalid coupon code");
      }
    } catch (err) {
      setCouponState({
        status: "invalid",
        reason: "Unable to validate code. Please try again.",
      });
      toast.error("Unable to validate code. Please try again.");
    } finally {
      setCouponValidating(false);
    }
  }

  function clearCoupon() {
    setCouponCode("");
    setCouponState(null);
  }

  const isOrg = scope === "organization";
  const orgRole = me?.role;
  const canManageOrg = isOrg && (orgRole === "owner" || orgRole === "admin");
  const currentPlanCode = me?.subscription?.plan?.code || "free";
  const currentStripePriceId = me?.subscription?.stripePriceId || null;
  const currentInterval = currentStripePriceId
    ? (me?.subscription?.plan?.prices || []).find(p => p.stripePriceId === currentStripePriceId)?.interval || null
    : null;
  const hasCustomer = !!me?.hasStripeCustomer;
  const hasActive = !!me?.hasActiveSubscription;
  const nextBilling = me?.subscription?.currentPeriodEnd
    ? new Date(me.subscription.currentPeriodEnd)
    : null;

  function filteredPlans() {
    const wantContext = isOrg ? "organization" : "individual";
    return (plans || []).filter(
      (p) => !p?.context || p.context === wantContext,
    );
  }

  function priceFor(p) {
    const pr = (p.prices || []).find(
      (x) => x.interval === billingInterval && x.active,
    );
    if (!pr) return null;
    const percent =
      billingInterval === "month"
        ? p.discount?.monthPercent || 0
        : p.discount?.yearPercent || 0;
    // unitAmount comes from /api/plans which multiplies ×100, so divide back to dollars
    const base = pr.unitAmount / 100;
    // If a valid coupon is applied, override the plan-level discount display
    let final = percent > 0 ? base * (1 - percent / 100) : base;
    if (couponState?.status === "valid" && couponState.discount) {
      const d = couponState.discount;
      if (d.type === "percentage") {
        final = base * (1 - d.value / 100);
      } else if (d.type === "fixed_amount") {
        final = Math.max(0, base - d.value);
      }
    }
    return {
      stripePriceId: pr.stripePriceId,
      base,
      final,
      percent,
      currency: pr.currency || "usd",
    };
  }

  async function goCheckout(stripePriceId) {
    setBusy(true);
    try {
      const url =
        process.env.REACT_APP_BACKEND_URL +
        (isOrg ? "/api/org-billing/checkout" : "/api/billing/checkout");
      const body = { stripePriceId };
      // Only pass coupon code if it has been validated successfully
      if (couponState?.status === "valid" && couponCode.trim()) {
        body.promotionCode = couponCode.trim().toUpperCase();
      }
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) {
        // Show the server error clearly — coupon may have just expired server-side
        const msg =
          data.message || "Failed to start checkout. Please try again.";
        toast.error(msg);
        // If the error is about the coupon, clear the coupon state so user sees it's rejected
        if (
          data.message?.toLowerCase().includes("coupon") ||
          data.message?.toLowerCase().includes("code")
        ) {
          setCouponState({ status: "invalid", reason: msg });
        }
        return;
      }
      if (data.url) window.location.href = data.url;
    } catch {
      toast.error("Failed to start checkout. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  async function openPortal() {
    setBusy(true);
    try {
      const url =
        process.env.REACT_APP_BACKEND_URL +
        (isOrg ? "/api/org-billing/portal" : "/api/billing/portal");
      const res = await fetch(url, { method: "POST", credentials: "include" });
      if (res.ok) {
        const { url: redirect } = await res.json();
        if (redirect) window.location.href = redirect;
      } else toast.error("No billing profile yet. Please upgrade first.");
    } catch {
      toast.error("Failed to access billing portal. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  if (loading) {
    return (
      <div className="up-loading" style={{ minHeight: "60vh" }}>
        <div className="up-spinner" style={{ width: 24, height: 24 }} />
        Loading your subscription details…
      </div>
    );
  }

  const list = filteredPlans();
  const currentPlanIndex = list.findIndex(p => p.code === currentPlanCode);
  const currentPlan = list.find((p) => p.code === currentPlanCode) ||
    plans.find((p) => p.code === currentPlanCode) || {
      name: "Free",
      code: "free",
    };
  const soloProjectsDefault = planDefaultMax(currentPlan.code);
  const orgProjectsDefault = orgDefaultSeats(currentPlan.code);

  const individualFeatures = [
    { key: "projects.max", type: "int", label: "Projects limit" },
    { key: "feat.3d", label: "3D Design Tools" },
    { key: "feat.2d", label: "2D Drawing Tools" },
    { key: "feat.estimator", label: "Auto Cost Estimator" },
  ];
  const orgFeatures = [
    { key: "org.projects.max", type: "int", label: "Projects limit" },
    {
      key: "member.projects.max",
      type: "int",
      label: "Per-member projects limit",
    },
    { key: "feat.3d", label: "3D Design Tools" },
    { key: "feat.2d", label: "2D Drawing Tools" },
    { key: "feat.branding", label: "Custom Branding" },
    { key: "feat.estimator", label: "Auto Cost Estimator" },
  ];
  const features = isOrg ? orgFeatures : individualFeatures;
  const compareColumns = isOrg
    ? [
        { key: "org.projects.max", label: "Projects limit", type: "int" },
        { key: "member.projects.max", label: "Per-member limit", type: "int" },
        { key: "feat.3d", label: "3D Tools" },
        { key: "feat.2d", label: "2D Tools" },
        { key: "feat.branding", label: "Custom Branding" },
        { key: "feat.estimator", label: "Auto Estimator" },
      ]
    : [
        { key: "projects.max", label: "Projects limit", type: "int" },
        { key: "feat.3d", label: "3D Tools" },
        { key: "feat.2d", label: "2D Tools" },
        { key: "feat.estimator", label: "Auto Estimator" },
      ];

  return (
    <div className="sub-wrap">
      {/* Header */}
      <div style={{ marginBottom: "24px" }}>
        <div className="up-title">
          {isOrg ? "Company Subscription" : "Your Subscription"}
        </div>
        <div className="up-sub">
          {isOrg
            ? orgHeaderText(me?.role)
            : "Unlock powerful design tools and advanced features"}
        </div>
      </div>

      {/* Current plan banner */}
      {hasActive ? (
        <div className={`sub-banner sub-banner-active`}>
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <div className="sub-banner-icon">
              <Crown size={20} style={{ color: "#eeff03" }} />
            </div>
            <div>
              <div className="sub-banner-title">{currentPlan.name} Plan</div>
              <div className="sub-banner-sub">
                {nextBilling
                  ? `Renews ${nextBilling.toLocaleDateString()}`
                  : "Active subscription"}
              </div>
            </div>
          </div>
          {(!isOrg || canManageOrg) && (
            <button
              className="up-btn"
              style={{ background: "#ffffff", color: "#111111" }}
              onMouseEnter={e => e.currentTarget.style.background = "#f0f0f0"}
              onMouseLeave={e => e.currentTarget.style.background = "#ffffff"}
              onClick={openPortal}
              disabled={busy}
            >
              <CreditCard size={14} /> Manage Billing
            </button>
          )}
        </div>
      ) : (
        <div className={`sub-banner sub-banner-upgrade`}>
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <div className="sub-banner-icon">
              <Sparkles size={20} style={{ color: "#eeff03" }} />
            </div>
            <div>
              <div className="sub-banner-title">
                {isOrg
                  ? "Upgrade your company plan"
                  : "Upgrade to unlock premium features"}
              </div>
              <div className="sub-banner-sub">
                {isOrg
                  ? "Get advanced tools and more seats"
                  : "Access advanced tools and unlimited projects"}
              </div>
            </div>
          </div>
          <a
            href="#plans"
            className="up-btn up-btn-white"
            style={{ textDecoration: "none" }}
          >
            <Zap size={14} /> See Plans
          </a>
        </div>
      )}

      {/* Billing interval toggle */}
      <div className="sub-interval-toggle">
        <div className="sub-interval-wrap">
          <button
            className={`sub-interval-btn ${billingInterval === "month" ? "active" : ""}`}
            onClick={() => setBillingInterval("month")}
          >
            Monthly
          </button>
          <button
            className={`sub-interval-btn ${billingInterval === "year" ? "active" : ""}`}
            onClick={() => setBillingInterval("year")}
          >
            Annually
          </button>
        </div>
      </div>

      {/* Coupon code input — shown only when the user doesn't already have an active plan */}
      {(!hasActive || !(isOrg && !canManageOrg)) && (
        <div className="sub-coupon-wrap">
          <div style={{ textAlign: "center", marginBottom: 2 }}>
            <span
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 11,
                letterSpacing: "0.04em",
                color: "#9ca3af",
              }}
            >
              Have a coupon code?
            </span>
          </div>
          <div className="sub-coupon-row">
            <input
              className={`sub-coupon-input${couponState?.status === "valid" ? " valid" : couponState?.status === "invalid" ? " invalid" : ""}`}
              type="text"
              placeholder="XXXX-XXXX-XXXX"
              value={couponCode}
              onChange={(e) => {
                setCouponCode(e.target.value.toUpperCase());
                // Clear feedback when user edits the code
                if (couponState) setCouponState(null);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && couponCode.trim() && !couponValidating)
                  validateCoupon();
              }}
              disabled={couponState?.status === "valid"}
              maxLength={20}
              autoComplete="off"
              spellCheck={false}
            />
            {couponState?.status === "valid" ? (
              <button
                className="sub-coupon-apply"
                style={{ background: "#10b981" }}
                onClick={clearCoupon}
              >
                <Check size={13} /> Applied
              </button>
            ) : (
              <button
                className="sub-coupon-apply"
                onClick={validateCoupon}
                disabled={!couponCode.trim() || couponValidating}
              >
                {couponValidating ? (
                  <>
                    <RefreshCw
                      size={13}
                      style={{ animation: "upSpin .7s linear infinite" }}
                    />{" "}
                    Checking…
                  </>
                ) : (
                  <>
                    <Gift size={13} /> Apply
                  </>
                )}
              </button>
            )}
          </div>

          {/* Inline feedback */}
          {couponState?.status === "valid" && (
            <div className="sub-coupon-feedback valid">
              <Check size={14} />
              <span>
                <strong>{couponState.discount?.label}</strong> will be applied
                at checkout
                {couponState.expiresAt && (
                  <span style={{ opacity: 0.7, marginLeft: 6 }}>
                    · expires{" "}
                    {new Date(couponState.expiresAt).toLocaleDateString(
                      "en-US",
                      { month: "short", day: "numeric" },
                    )}
                  </span>
                )}
              </span>
              <button className="sub-coupon-clear" onClick={clearCoupon}>
                Remove
              </button>
            </div>
          )}
          {couponState?.status === "invalid" && (
            <div className="sub-coupon-feedback invalid">
              <X size={14} />
              <span>{couponState.reason}</span>
            </div>
          )}
        </div>
      )}

      {/* Plans grid */}
      <div
        id="plans"
        className="sub-plans-grid"
        style={{
          gridTemplateColumns: `repeat(${Math.min(list.length, 4)}, 1fr)`,
        }}
      >
        <style>{`@media (max-width:1023px) { .sub-plans-grid { grid-template-columns: repeat(2,1fr) !important; } } @media (max-width:599px) { .sub-plans-grid { grid-template-columns: 1fr !important; } }`}</style>
        {list.map((plan, index) => {
          const price = priceFor(plan);
          const isSamePlan = plan.code === currentPlanCode;
          const isCurrent = isSamePlan && (!currentInterval || billingInterval === currentInterval);
          const isIntervalSwitch = isSamePlan && !!currentInterval && billingInterval !== currentInterval;
          const isDowngrade = !isSamePlan && currentPlanIndex > -1 && index < currentPlanIndex;
          const isPopular = index === 1;
          const canBuy = isOrg ? canManageOrg : true;

          return (
            <div
              key={plan.id}
              className={`sub-plan-card ${isPopular && !isCurrent ? "popular" : ""} ${isCurrent ? "current" : ""}`}
            >
              {isPopular && !isCurrent && (
                <div className="sub-plan-badge popular">Most Popular</div>
              )}
              {isCurrent && (
                <div className="sub-plan-badge current">Current Plan</div>
              )}
              <div
                className="sub-plan-body"
                style={{ paddingTop: isPopular || isCurrent ? "32px" : "24px" }}
              >
                <div className="sub-plan-name">{plan.name}</div>
                <div className="sub-plan-desc">
                  {plan.description || "Perfect for getting started"}
                </div>
                <div className="sub-plan-price">
                  {price ? `$${price.final.toFixed(2)}` : "$0"}
                </div>
                <div className="sub-plan-interval">per {billingInterval}</div>
                {price?.percent > 0 && !couponState?.discount && (
                  <div className="sub-plan-discount">
                    <Gift size={10} /> {price.percent}% off
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#9ca3af",
                        marginLeft: 4,
                      }}
                    >
                      ${price.base.toFixed(2)}
                    </span>
                  </div>
                )}
                {couponState?.status === "valid" &&
                  couponState.discount &&
                  price && (
                    <div
                      className="sub-plan-discount"
                      style={{
                        background: "rgba(16,185,129,0.1)",
                        color: "#065f46",
                      }}
                    >
                      <Gift size={10} /> {couponState.discount.label} applied
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#9ca3af",
                          marginLeft: 4,
                        }}
                      >
                        ${price.base.toFixed(2)}
                      </span>
                    </div>
                  )}
                <div className="sub-plan-features">
                  {features.map((feat) => (
                    <div key={feat.key} className="sub-plan-feat-row">
                      <div
                        className={`sub-plan-feat-icon ${feat.type === "int" || has(plan, feat.key) ? "yes" : "no"}`}
                      >
                        {feat.type === "int" || has(plan, feat.key) ? (
                          <Check size={10} style={{ color: "#10b981" }} />
                        ) : (
                          <X size={10} style={{ color: "#9ca3af" }} />
                        )}
                      </div>
                      <span
                        style={{
                          color:
                            feat.type === "int" || has(plan, feat.key)
                              ? "#0c1118"
                              : "#9ca3af",
                        }}
                      >
                        {feat.type === "int"
                          ? `${feat.label}: ${featureValue(plan, feat.key, feat.key === "projects.max" ? planDefaultMax(plan.code) : feat.key === "org.projects.max" ? 50 : feat.key === "member.projects.max" ? 5 : planDefaultMax(plan.code))}`
                          : feat.label}
                      </span>
                    </div>
                  ))}
                </div>
                <button
                  className={`sub-plan-cta ${
                    isCurrent ? "current"
                    : !canBuy || !price ? "disabled"
                    : isDowngrade ? "downgrade"
                    : "upgrade"
                  }`}
                  disabled={isCurrent || !price || busy || !canBuy}
                  onClick={() => price && goCheckout(price.stripePriceId)}
                >
                  {busy ? (
                    <RefreshCw
                      size={14}
                      style={{ animation: "upSpin .7s linear infinite" }}
                    />
                  ) : isCurrent ? (
                    "Current Plan"
                  ) : isIntervalSwitch ? (
                    billingInterval === "year" ? "Switch to Annual" : "Switch to Monthly"
                  ) : isDowngrade ? (
                    "Downgrade"
                  ) : (
                    "Upgrade Now"
                  )}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Account info cards */}
      <div style={{ marginBottom: "12px" }}>
        <div className="up-title">
          {isOrg ? "Organization" : "Account"} Information
        </div>
      </div>
      <div className="sub-info-grid">
        <div className="sub-info-card">
          <div className="sub-info-title">Current Plan</div>
          <div className="sub-info-value">{currentPlan.name}</div>
          <div className="sub-info-sub">
            {isOrg
              ? `Projects: ${featureValue(currentPlan, "org.projects.max", 50)} · Per-member: ${featureValue(currentPlan, "member.projects.max", 5)}`
              : `Projects: ${featureValue(currentPlan, "projects.max", soloProjectsDefault)}`}
          </div>
        </div>
        <div className="sub-info-card">
          <div className="sub-info-title">Next Billing</div>
          {nextBilling ? (
            <>
              <div className="sub-info-value">
                {nextBilling.toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })}
              </div>
              <div className="sub-info-sub">Auto-renewal enabled</div>
            </>
          ) : (
            <div className="sub-info-value" style={{ color: "#9ca3af" }}>
              No upcoming charges
            </div>
          )}
        </div>
        <div className="sub-info-card">
          <div className="sub-info-title">Payment Method</div>
          {hasCustomer && hasActive ? (
            !isOrg || canManageOrg ? (
              <button
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#111111",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
                onClick={openPortal}
                disabled={busy}
              >
                Manage Payment <ExternalLink size={13} />
              </button>
            ) : (
              <div className="sub-info-value" style={{ color: "#9ca3af" }}>
                Managed by your organization
              </div>
            )
          ) : (
            <div className="sub-info-sub">
              No payment on file.{" "}
              {!isOrg || canManageOrg ? (
                <a href="#plans" style={{ color: "#111111", fontWeight: 500 }}>
                  Upgrade to add one
                </a>
              ) : (
                "Ask an org admin to upgrade."
              )}
            </div>
          )}
        </div>
      </div>

      {/* Feature comparison table */}
      <div style={{ marginBottom: "12px" }}>
        <div className="up-title">
          Feature Comparison
        </div>
      </div>
      <div className="sub-compare-table">
        <div style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                {list.map((plan) => (
                  <th key={plan.id}>{plan.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {compareColumns.map((col) => (
                <tr key={col.key}>
                  <td>{col.label}</td>
                  {list.map((plan) => (
                    <td key={plan.id}>
                      {col.type === "int" ? (
                        <span
                          style={{
                            fontFamily: "'DM Sans', sans-serif",
                            fontSize: "1.2rem",
                            color: "#000000",
                          }}
                        >
                          {featureValue(
                            plan,
                            col.key,
                            col.key === "projects.max"
                              ? planDefaultMax(plan.code)
                              : col.key === "org.projects.max"
                                ? 50
                                : col.key === "member.projects.max"
                                  ? 5
                                  : planDefaultMax(plan.code),
                          )}
                        </span>
                      ) : has(plan, col.key) ? (
                        <Check
                          size={16}
                          style={{ color: "#11d41b", margin: "0 auto" }}
                        />
                      ) : (
                        <X
                          size={16}
                          style={{ color: "#d1d5db", margin: "0 auto" }}
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
